export const IrgetterAbi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'comet',
        type: 'address',
      },
    ],
    name: 'getCometInterest',
    outputs: [
      {
        internalType: 'uint256',
        name: 'borrowRate',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'supplyRate',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'utilization',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const
